import PrivateRoute from 'utils/privateRoute';
import UnifiedAlertsDashboard from 'components/UnifiedAlerts';
import SnowUnifiedIncidentsDashboard from 'components/UnifiedAlerts/IncidentsDashboard';
import EarlyWarningSystemRule from 'components/UnifiedAlerts/EarlyWarningSystemRule';
import ManageSOPPage from 'components/UnifiedAlerts/ManageSOP/ManageSOPPage';

const UnifiedAlertsRoutes = [
  {
    key: 'unified_alerts_dashboard',
    route: '/dataops/unified-alerts',
    component: (
      <PrivateRoute
        Component={UnifiedAlertsDashboard}
        restrictedRoles={['Data Operations Admin', 'Data Operations User']}
      />
    ),
  },
  {
    key: 'unified_incidents_dashboard',
    route: '/dataops/unified-incidents',
    component: (
      <PrivateRoute
        Component={SnowUnifiedIncidentsDashboard}
        restrictedRoles={['Data Operations Admin', 'Data Operations User']}
      />
    ),
  },
  {
    key: 'early_warning_rule',
    route: '/dataops/early-warning-rule',
    component: (
      <PrivateRoute
        Component={EarlyWarningSystemRule}
        restrictedRoles={['Data Operations Admin', 'Data Operations User', 'PepWise System User']}
      />
    ),
  },
  {
    key: 'manage_sop_page',
    route: '/dataops/manage-sop',
    component: (
      <PrivateRoute
        Component={ManageSOPPage}
        restrictedRoles={['Data Operations Admin', 'Data Operations User']}
      />
    ),
  },
];

export default UnifiedAlertsRoutes;
